import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';
import WorkArea from './WorkArea'; // Import the renamed component


function App() {
  const [version, setVersion] = useState(null);
  // Color state is managed and updated here
  const [color, setColor] = useState('#d2db7f'); // default color: lightyellow
  const [fillColor, setFillColor] = useState('#22eb86'); // default fill color: green
  const [fillProps, setFillProps] = useState({ type: 'parallel', spacing: 2, segmentLength: 4, angle: 45 });

  // Simulation state
  const [currentStitchIndex, setCurrentStitchIndex] = useState(0);
  const [totalStitches, setTotalStitches] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [simulationSpeed, setSimulationSpeed] = useState(50); // ms per stitch (lower = faster)

  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setCurrentStitchIndex((prev) => {
          if (prev >= totalStitches) {
            setIsPlaying(false);
            return totalStitches;
          }
          return prev + 10; // Increment by 10 for smoother animation
        });
      }, simulationSpeed);
    }
    return () => clearInterval(interval);
  }, [isPlaying, totalStitches, simulationSpeed]);

  // --- Component Render ---
  return (
    <div className="App">
      <WorkArea
        color={color}
        setColor={setColor}
        fillColor={fillColor}
        setFillColor={setFillColor}
        fillProps={fillProps}
        setFillProps={setFillProps}
        currentStitchIndex={currentStitchIndex}
        setCurrentStitchIndex={setCurrentStitchIndex}
        totalStitches={totalStitches}
        setTotalStitches={setTotalStitches}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        simulationSpeed={simulationSpeed}
        setSimulationSpeed={setSimulationSpeed}
      />
      {/* {version && <p>Version: {version}</p>} */}
    </div>
  );
}

export default App;